module.exports = __webpack_public_path__ + "img/thumb_12.3ba7b61c.png";